import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NxViewportService {
  
  constructor() { }

  // OLD CODE
  private _mediaQuery = new BehaviorSubject<any>('');
  mediaQuery$ = this._mediaQuery.asObservable();
  updateMedia(data: any) {   
    this._mediaQuery.next(data);  // other option ({url: data})
    // console.log("Mediaquery service >>", data);
  }

  // NEW CODE SWAP
  private _viewportQuery = new BehaviorSubject<any>('');
  viewport$ = this._viewportQuery.asObservable();
  update(data: any) {   
    this._viewportQuery.next(data);  // other option ({url: data})
    // console.log("Mediaquery service >>", data);
  }



  
}

export interface Viewport {
  name: string;
  width: number;
  height: number;
  orientation: string;
  class: string;
  position: number;
}
